import { styled } from '@mui/material/styles';
import backgroundImage from './images/opportunity.jpg';

export const HeaderImage = styled('div')(({ theme }) => ({
  background: `url(${backgroundImage})`,
  position: 'relative',
  height: '287px',
  flexGrow: 1,
  backgroundSize: 'cover',
  padding: theme.spacing(4, 2.5, 2, 2.5),
  boxSizing: 'border-box',
  display: 'flex',
  alignItems: 'flex-start',
  flexDirection: 'column',
  justifyContent: 'space-between'
}));

export const Container = styled('div')(() => ({
  display: 'flex',
  flexDirection: 'column'
}));

export const Description = styled('p')(({ theme }) => ({
  margin: `${theme.spacing(1)} 0 ${theme.spacing(2)}`
}));

export const Subtitle = styled('div')(({ theme }) => ({
  color: theme.color.primary.contrast,
  fontSize: theme.fontSize.xxl,
  fontWeight: theme.fontWeight.bold,
  textTransform: 'uppercase',
  width: '400px',
  maxWidth: '100%'
}));
